import { ActionTree, ActionContext } from 'vuex';

import { usersClient } from '@/http-client';
import { snakeToCamel } from '@/utils';

import { RootStateI } from '../state';
import { AuthStateI, GoogleProjectI } from './state';

export const actions: ActionTree<AuthStateI, RootStateI> = {
  async confirmSession(
    context: ActionContext<AuthStateI, RootStateI>,
    payload: {
      token: string,
      redirect: string,
    },
  ) {
    if (!payload.token) {
      const { VUE_APP_DIGI_USERS_F } = process.env;
      window.location.href = `${VUE_APP_DIGI_USERS_F}/auth/provider?app=fireweb`;
      return;
    }
    context.commit('setToken', payload.token);
    await context.dispatch('getUserDetails');
    // await context.dispatch('getUserPermissions');
    await context.dispatch('getUserProjects');
    window.location.href = `/app?redirect=${payload.redirect}`;
  },
  async getUserDetails(context: ActionContext<AuthStateI, RootStateI>) {
    const { data } = await usersClient.get('/api/auth/userdetailsv2');
    context.commit('setUser', snakeToCamel(data));
  },
  async getUserPermissions(context: ActionContext<AuthStateI, RootStateI>) {
    const { data } = await usersClient.get('/api/auth/userperms');
    context.commit('setPermissions', data);
  },
  async getUserProjects(context: ActionContext<AuthStateI, RootStateI>) {
    const { data } = await usersClient.get('/api/auth/getgoogleprojects');
    context.commit('setProjects', snakeToCamel(data.projects));
  },
  logout(context: ActionContext<AuthStateI, RootStateI>) {
    context.commit('setToken', '');
    context.commit('setUser', '');
    context.commit('setPermissions', '');
    context.commit('setProjects', '');
    const { VUE_APP_DIGI_USERS_F } = process.env;
    window.location.href = `${VUE_APP_DIGI_USERS_F}/auth/provider?app=fireweb`;
  },
  changeProject(context: ActionContext<AuthStateI, RootStateI>, payload: number | string) {
    // get current project from getters
    const { projects } = context.getters;
    // find the project with the given id
    const project = projects.find((p: GoogleProjectI) => p.projectId === payload);

    if (project) {
      context.commit('setProject', project);
      // reload the page with cache
      // Clear cache and reload by navigating to the same URL
      // but keep the query params
      const url = window.location.href;
      const query: Record<string, string> = {};
      const queryParams = url.split('?');
      if (queryParams.length > 1) {
        const params = queryParams[1].split('&');
        params.forEach((p: string) => {
          const [key, value] = p.split('=');
          query[key] = value;
        });
      }
      query.project = project.projectId.toString();
      const newUrl = `${url.split('?')[0]}?${Object.entries(query).map(([key, value]) => `${key}=${value}`).join('&')}`;
      window.location.href = newUrl;
    }
  },
  async refreshToken(context: ActionContext<AuthStateI, RootStateI>) {
    const { data } = await usersClient.post('/api/auth/refreshtoken');
    context.commit('setToken', data);
  },
};
